import { container } from '@shared/common/dependency-injection/domain/container';
import type { JwtRepositoryInterface } from '@shared/common/network/domain/repository/jwt.repository';
import { NetworkDependencyTypes } from '@shared/common/network/network.dependency-types';
import { HomeRouteName } from '@shared/feature/home/domain/route/home.route-name';
import type { RouteLocationRaw } from 'vue-router';

export function redirectIfAlreadyAuthenticated(): boolean | RouteLocationRaw {
  const jwtRepository = container.get<JwtRepositoryInterface>(NetworkDependencyTypes.JwtRepository);

  return jwtRepository.hasToken() ? { name: HomeRouteName.Home } : true;
}
